const c = {
  name: "MystoreWave",
  dimensions: { width: 40, height: 10 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 10" style="enable-background:new 0 0 40 10;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.3,1.5C7.3,0.6,8.4,0,10,0c1.6,0,2.7,0.6,3.7,1.5c0.9,0.8,1.6,1.9,2.2,2.9l0,0.1c0.6,1,1.2,1.9,1.9,2.6
			c0.6,0.6,1.3,1,2.3,1c0.9,0,1.6-0.4,2.3-1c0.7-0.6,1.2-1.5,1.9-2.6l0-0.1c0.6-1,1.3-2.1,2.2-2.9C27.3,0.6,28.4,0,30,0
			c1.6,0,2.7,0.6,3.7,1.5c0.9,0.8,1.6,1.9,2.2,2.9l0,0.1c0.6,1,1.2,1.9,1.9,2.6c0.6,0.6,1.3,1,2.3,1v2c-1.6,0-2.7-0.6-3.7-1.5
			c-0.9-0.8-1.6-1.9-2.2-2.9l0-0.1c-0.6-1-1.2-1.9-1.9-2.6c-0.6-0.6-1.3-1-2.3-1c-0.9,0-1.6,0.4-2.3,1c-0.7,0.6-1.2,1.5-1.9,2.6
			l0,0.1c-0.6,1-1.3,2.1-2.2,2.9C22.7,9.4,21.6,10,20,10c-1.6,0-2.7-0.6-3.7-1.5c-0.9-0.8-1.6-1.9-2.2-2.9l0-0.1
			c-0.6-1-1.2-1.9-1.9-2.6c-0.6-0.6-1.3-1-2.3-1C9.1,2,8.4,2.4,7.7,3C7,3.6,6.5,4.5,5.8,5.5c0,0,0,0,0,0.1c-0.6,1-1.3,2.1-2.2,2.9
			C2.7,9.4,1.6,10,0,10V8c0.9,0,1.6-0.4,2.3-1C3,6.4,3.5,5.5,4.2,4.5c0,0,0,0,0-0.1C4.8,3.5,5.5,2.4,6.3,1.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as MystoreWave
};
